<template>
  <div class="pb-2">
    <div class="p-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <input-field
            name="raw_key-iv"
            label="IV*"
            label-position="top"
          >
            <div
              v-clipboard:copy="settings.iv"
              v-clipboard:success="copySuccess"
              class="text-wrap w-100 link cursor-pointer"
            >
              {{ settings.iv || '-' }}
              <GjIcon
                v-if="settings.iv"
                name="Copy"
                size="20"
              />
            </div>
          </input-field>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <input-field
            name="raw_key-pssh"
            label="PSSH*"
            label-position="top"
          >
            <div
              v-clipboard:copy="settings.pssh"
              v-clipboard:success="copySuccess"
              class="text-wrap w-100 link cursor-pointer"
            >
              {{ settings.pssh || '-' }}
              <GjIcon
                v-if="settings.pssh"
                name="Copy"
                size="20"
              />
            </div>
          </input-field>
        </b-col>
      </b-row>
    </div>
    <div class="d-flex flex-column border-default border-t rawKeyTable">
      <div class="d-flex justify-content-between align-items-center p-2">
        <div class="text-lg text-thick">
          Raw Keys
        </div>
      </div>
      <div class="default-table shadow-none border-none table-compact">
        <b-table-simple
          responsive
          class="loaded"
          table-class="mt-0"
        >
          <b-thead>
            <b-tr>
              <b-th>
                Label
              </b-th>
              <b-th>
                Key ID
              </b-th>
              <b-th>
                Key
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="item in rawKeyTableItems"
              :key="item.id"
            >
              <b-td class="pb-0">
                <div>
                  {{ item.label }}
                </div>
              </b-td>
              <b-td class="pb-0">
                <div
                  v-clipboard:copy="item.keyId"
                  v-clipboard:success="copySuccess"
                  class="link cursor-pointer"
                >
                  {{ item.keyId || '-' }}
                  <GjIcon
                    v-if="item.keyId"
                    name="Copy"
                    size="20"
                  />
                </div>
              </b-td>
              <b-td
                v-clipboard:copy="item.key"
                v-clipboard:success="copySuccess"
                class="pb-0 link cursor-pointer"
              >
                <div>
                  {{ item.key || '-' }}
                  <GjIcon
                    v-if="item.key"
                    name="Copy"
                    size="20"
                  />
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
  </div>
</template>
<script>
import InputField from '@/components/form/InputField.vue'

export default {
  name: 'RawKey',
  components: {
    InputField,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rawKeyField: {
        label: '',
        keyId: '',
        key: '',
        tdClass: 'pb-0',
      },
    }
  },
  computed: {
    rawKeyTableItems() {
      return this.settings.rawKeys
    },
  },
}
</script>
<style>
.rawKeyTable table tr td {
  padding-bottom: 5px;
}
</style>
